export function VMCIcon({ width }: { width?: number }) {
  return (
    <svg
      id="svg5"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x={0}
      y={0}
      width={width ?? 'fit-content'}
      viewBox="-38 0 409 155"
      xmlSpace="preserve"
    >
      <style>
        {
          '.st1,.st3{stroke:#000;stroke-width:13}.st3{display:inline;fill:none;stroke-width:12.9402;stroke-miterlimit:11.3386}'
        }
      </style>
      <g id="layer1">
        <g>
          <path
            className="st1"
            d="M43.3 130 6.4 27H29l26.1 76.3L80.3 27h22.1L65.5 130H43.3zM112.7 130V27h31.1l18.7 70.3L181.1 27h31.2v103H193V48.9L172.5 130h-20l-20.4-81.1V130h-19.4zM298.9 92.1l20.2 6.4c-3.1 11.2-8.2 19.6-15.4 25.1-7.2 5.5-16.3 8.2-27.4 8.2-13.7 0-24.9-4.7-33.8-14-8.8-9.4-13.2-22.1-13.2-38.4 0-17.2 4.4-30.5 13.3-40s20.5-14.2 34.9-14.2c12.6 0 22.9 3.7 30.7 11.2 4.7 4.4 8.2 10.7 10.5 19l-20.6 4.9c-1.2-5.3-3.8-9.6-7.6-12.7s-8.5-4.6-14-4.6c-7.6 0-13.8 2.7-18.6 8.2-4.8 5.5-7.1 14.4-7.1 26.6 0 13 2.3 22.3 7 27.8s10.8 8.3 18.3 8.3c5.5 0 10.3-1.8 14.3-5.3 3.9-3.4 6.8-8.9 8.5-16.5z"
          />
        </g>
        <defs>
          <path
            id="SVGID_1_"
            d="M43.1 130 6.2 27h22.6l26.1 76.3L80.1 27h22.1L65.3 130H43.1zm69.4 0V27h31.1l18.7 70.3L180.9 27h31.2v103h-19.3V48.9L172.3 130h-20l-20.4-81.1V130h-19.4zm186.2-37.9 20.2 6.4c-3.1 11.2-8.2 19.6-15.4 25.1-7.2 5.5-16.3 8.2-27.4 8.2-13.7 0-24.9-4.7-33.8-14-8.8-9.4-13.2-22.1-13.2-38.4 0-17.2 4.4-30.5 13.3-40s20.5-14.2 34.9-14.2c12.6 0 22.9 3.7 30.7 11.2 4.7 4.4 8.2 10.7 10.5 19L298 60.3c-1.2-5.3-3.8-9.6-7.6-12.7s-8.6-4.6-14.1-4.6c-7.6 0-13.8 2.7-18.6 8.2-4.8 5.5-7.1 14.4-7.1 26.6 0 13 2.3 22.3 7 27.8s10.8 8.3 18.3 8.3c5.5 0 10.3-1.8 14.3-5.3 3.9-3.4 6.8-8.9 8.5-16.5z"
          />
        </defs>
        <clipPath id="SVGID_00000171690416550374830970000000907944833478664327_">
          <use
            xlinkHref="#SVGID_1_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <g
          id="g16067"
          style={{
            clipPath:
              'url(#SVGID_00000171690416550374830970000000907944833478664327_)',
          }}
        >
          <g id="g16062">
            <path
              id="path14112"
              d="m3.4 13 24.9 12.8 33.2 105.7L6.3 130 3.4 13z"
              style={{
                fill: '#72d772',
                stroke: '#72d772',
                strokeWidth: 0.7512,
                strokeMiterlimit: 11.3386,
              }}
            />
            <path
              id="path14114"
              d="m61.5 131.5 41.5.4V13l-41-.6-8.5 93.8 8 25.3z"
              style={{
                fill: '#ebffea',
                stroke: '#ebffea',
                strokeWidth: 0.75,
                strokeMiterlimit: 11.3386,
              }}
            />
          </g>
        </g>
        <defs>
          <path
            id="SVGID_00000124876150363612327930000017999671800863297454_"
            d="M43.1 130 6.2 27h22.6l26.1 76.3L80.1 27h22.1L65.3 130H43.1zm69.4 0V27h31.1l18.7 70.3L180.9 27h31.2v103h-19.3V48.9L172.3 130h-20l-20.4-81.1V130h-19.4zm186.2-37.9 20.2 6.4c-3.1 11.2-8.2 19.6-15.4 25.1-7.2 5.5-16.3 8.2-27.4 8.2-13.7 0-24.9-4.7-33.8-14-8.8-9.4-13.2-22.1-13.2-38.4 0-17.2 4.4-30.5 13.3-40s20.5-14.2 34.9-14.2c12.6 0 22.9 3.7 30.7 11.2 4.7 4.4 8.2 10.7 10.5 19L298 60.3c-1.2-5.3-3.8-9.6-7.6-12.7s-8.6-4.6-14.1-4.6c-7.6 0-13.8 2.7-18.6 8.2-4.8 5.5-7.1 14.4-7.1 26.6 0 13 2.3 22.3 7 27.8s10.8 8.3 18.3 8.3c5.5 0 10.3-1.8 14.3-5.3 3.9-3.4 6.8-8.9 8.5-16.5z"
          />
        </defs>
        <clipPath id="SVGID_00000118382035947067492330000017977927480819863957_">
          <use
            xlinkHref="#SVGID_00000124876150363612327930000017999671800863297454_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <g
          id="g20751"
          style={{
            clipPath:
              'url(#SVGID_00000118382035947067492330000017977927480819863957_)',
          }}
        >
          <path
            id="path19293"
            d="m176.4 130-32-104.3L103 13v118.5h72.6l.8-1.5z"
            style={{
              fill: '#56a8ec',
            }}
          />
          <path
            id="path19295"
            d="M144.4 25.8h83.7v105.7h-52.5l.8-1.4-32-104.3z"
            style={{
              fill: '#e4f4fe',
            }}
          />
        </g>
        <defs>
          <path
            id="SVGID_00000059285954370897245460000013519076050466180264_"
            d="M43.1 130 6.2 27h22.6l26.1 76.3L80.1 27h22.1L65.3 130H43.1zm69.4 0V27h31.1l18.7 70.3L180.9 27h31.2v103h-19.3V48.9L172.3 130h-20l-20.4-81.1V130h-19.4zm186.2-37.9 20.2 6.4c-3.1 11.2-8.2 19.6-15.4 25.1-7.2 5.5-16.3 8.2-27.4 8.2-13.7 0-24.9-4.7-33.8-14-8.8-9.4-13.2-22.1-13.2-38.4 0-17.2 4.4-30.5 13.3-40s20.5-14.2 34.9-14.2c12.6 0 22.9 3.7 30.7 11.2 4.7 4.4 8.2 10.7 10.5 19L298 60.3c-1.2-5.3-3.8-9.6-7.6-12.7s-8.6-4.6-14.1-4.6c-7.6 0-13.8 2.7-18.6 8.2-4.8 5.5-7.1 14.4-7.1 26.6 0 13 2.3 22.3 7 27.8s10.8 8.3 18.3 8.3c5.5 0 10.3-1.8 14.3-5.3 3.9-3.4 6.8-8.9 8.5-16.5z"
          />
        </defs>
        <clipPath id="SVGID_00000062178307424358223670000008621435784997516725_">
          <use
            xlinkHref="#SVGID_00000059285954370897245460000013519076050466180264_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <path
          id="rect21531"
          style={{
            clipPath:
              'url(#SVGID_00000062178307424358223670000008621435784997516725_)',
            fill: 'gray',
          }}
          d="M228.1 25.8h94.2v105.7h-94.2z"
        />
        <defs>
          <path
            id="SVGID_00000181074056262841969830000008336463051090668951_"
            d="M43.1 130 6.2 27h22.6l26.1 76.3L80.1 27h22.1L65.3 130H43.1zm69.4 0V27h31.1l18.7 70.3L180.9 27h31.2v103h-19.3V48.9L172.3 130h-20l-20.4-81.1V130h-19.4zm186.2-37.9 20.2 6.4c-3.1 11.2-8.2 19.6-15.4 25.1-7.2 5.5-16.3 8.2-27.4 8.2-13.7 0-24.9-4.7-33.8-14-8.8-9.4-13.2-22.1-13.2-38.4 0-17.2 4.4-30.5 13.3-40s20.5-14.2 34.9-14.2c12.6 0 22.9 3.7 30.7 11.2 4.7 4.4 8.2 10.7 10.5 19L298 60.3c-1.2-5.3-3.8-9.6-7.6-12.7s-8.6-4.6-14.1-4.6c-7.6 0-13.8 2.7-18.6 8.2-4.8 5.5-7.1 14.4-7.1 26.6 0 13 2.3 22.3 7 27.8s10.8 8.3 18.3 8.3c5.5 0 10.3-1.8 14.3-5.3 3.9-3.4 6.8-8.9 8.5-16.5z"
          />
        </defs>
        <clipPath id="SVGID_00000024701999824419055960000009018319417398583726_">
          <use
            xlinkHref="#SVGID_00000181074056262841969830000008336463051090668951_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <g
          id="g23821"
          style={{
            clipPath:
              'url(#SVGID_00000024701999824419055960000009018319417398583726_)',
          }}
        >
          <path
            id="path21637"
            d="M322.4 25.8h-94.2v52.8h94.2V25.8z"
            style={{
              fill: '#ed454f',
            }}
          />
          <path
            id="path21639"
            d="M322.4 78.6v52.8h-94.2V78.6h94.2z"
            style={{
              fill: '#ffe0e1',
            }}
          />
        </g>
      </g>
    </svg>
  );
}
